import type { useAuth0 } from "@auth0/auth0-react";
import ky, { isTimeoutError } from "ky";
import { getEnvironment } from "./environment";
import { getFeatureSearchParams } from "./features";

let getAccessToken: ReturnType<typeof useAuth0>["getAccessTokenSilently"];

export const configureAuth = (fn: ReturnType<typeof useAuth0>["getAccessTokenSilently"]) => {
  getAccessToken = fn;
};

export const api = ky.create({
  // Disable ky retries so React Query is the single retry layer (avoids stacked retries).
  retry: 0,
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        try {
          const accessToken = await getAccessToken();
          request.headers.set("Authorization", `Bearer ${accessToken}`);
        } catch (error) {
          const err = error instanceof Error ? error : new Error(String(error));
          err.name = "TOKEN_ACQUISITION_FAILED";
          throw err;
        }
      },
      ({ request }) => {
        if (!getEnvironment().internal) return;

        const overrides = getFeatureSearchParams();
        if (!Object.keys(overrides).length) return;

        const url = new URL(request.url);
        Object.entries(overrides).forEach(([k, v]) => url.searchParams.set(k, v));

        return new Request(url.toString(), request);
      },
    ],
    beforeError: [
      ({ error }) => {
        error.name = isTimeoutError(error) ? "NETWORK_TIMEOUT" : "API_REQUEST_FAILED";
        return error;
      },
    ],
  },
});
